import fetch from '@/utils/fetch'

// 获取支付红包信息
export function discountcard(params) {
  return fetch({
    url: '/discountcard/marketings',
    method: 'GET',
    params
  })
}